import script from "./radial-color-picker.vue?vue&type=script&setup=true&lang=ts"
export * from "./radial-color-picker.vue?vue&type=script&setup=true&lang=ts"

import "./radial-color-picker.vue?vue&type=style&index=0&id=67eba932&lang=scss"

const __exports__ = script;

export default __exports__